var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-image',_vm._g(_vm._b({staticClass:"b-image"},'el-image',_vm.$attrs,false),_vm.$listeners),[_c('div',{attrs:{"slot":"error"},slot:"error"},[_vm._t("error")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }